export {
  OnboardingCoachingInfoDialog,
  OnboardingCoachingInfoDialogProps,
} from './OnboardingCoachingInfoDialog';
